import { IObjectModelProperty } from '~/interfaces/objectModelInterfaces'
import ObjectModelPropertyDefinition from '~/models/objectModelProperties/objectModelPropertyDefinition'

export function label(property: IObjectModelProperty): string {
  return property.label_title || property.reference_name || `Untitled ${displayName(property)}`
}

export function displayName(property: IObjectModelProperty): string {
  return ObjectModelPropertyDefinition.getDisplayName(property.property_type);
}
